import React from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import Modal from "../Modal/Modal";
import "./DialogOverlay.scss";

class DialogOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  static propTypes = {
    callToAction: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.string
    ]),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
    className: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string
    ]),
    ctaDisabled: PropTypes.bool,
    dialogDescriptionID: PropTypes.string.isRequired,
    dialogTitleID: PropTypes.string.isRequired,
    dismissModalButton: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.string
    ]),
    intl: PropTypes.object.isRequired,
    onAction: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    role: PropTypes.oneOf(["dialog", "alertdialog"]).isRequired,
    triggerText: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.string
    ]).isRequired
  };

  static defaultProps = {
    ctaDisabled: false,
    role: "dialog"
  };
  
  handleClose(e) {
    const {onClose} = this.props;
    
    onClose && onClose(e);
    this.setState({
      isOpen: false
    });
  }

  handleOpen(e) {
    const {onOpen} = this.props;
    
    onOpen && onOpen(e);

    this.setState({
      isOpen: true
    });
  }

  render() {
    const {isOpen} = this.state;
    const {
      triggerText
    } = this.props;

    return (
      <>
        <button
          className="DialogTrigger"
          onClick={this.handleOpen}
          ref={this.setOpenButtonRef}>
          {triggerText}
        </button>
        <Modal 
          isOpen={isOpen}
          {...this.props}
          onClose={this.handleClose}
        />
      </>
    );
  }
}

export default injectIntl(DialogOverlay);
